import axios from '../../../../utils/request';

function GET_LIST(params) {
    return axios.get("/member/ALangset/index",{
        params: {
            page:params
        }
    } )
}

function GET_LANGUAGEPACK(params) {
    return axios.get("/member/ALangsetPack/index",{
        params: {
            ...params
        }
    } )
}
function GET_EDITLIST(params) {
    return axios.get("/member/ALangsetPack/edit",{   params: {
            ...params
        } }  )
}
function SUBMIT_EDITLIST(params) {
    return axios.post("/member/ALangsetPack/editPost",{langContent:params }  )
}

function GET_EDITLISTS(params) {
    return axios.get("/member/ALangsetPack/editFieldContent",{   params: {
            ...params
        } }  )
}
function SUBMIT_EDITLISTS(params) {
    return axios.post("/member/ALangsetPack/editBatchContentPost",{langContent:params }  )
}
function LIST_ORDER(params) {
    return axios.post("/member/ALangset/statusEdit",{status:params }  )
}
function ALANGSET_EDIT(params) {
    return axios.get("/member/ALangset/edit",{   params: {
            ...params
        } }  )
}
function ALANGSET_EDITPOST(params) {
    return axios.post("/member/ALangset/editPost",{...params }  )
}

export default {
    GET_LIST,
    GET_LANGUAGEPACK,
    GET_EDITLIST,
    SUBMIT_EDITLIST,
    GET_EDITLISTS,
    SUBMIT_EDITLISTS,
    LIST_ORDER,
    ALANGSET_EDIT,
    ALANGSET_EDITPOST

};
